import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router'
import { Form, Formik } from 'formik'

import BackButtonLayout from '../BackButtonLayout'
import {
  pathToLeadingPage,
  pathToRootPage,
} from '../../containers/App/RouterApp'
import { useClaimant } from '../../context/col'
import { isDEV } from '../../helpers'
import theme, { specialTheme } from '../../theme'
import { useStyles } from '../../pages/styled'
import Container from '@material-ui/core/Container'
import ReportButton from '../ReportButton'
import ReactHtmlParser from 'react-html-parser'
import TextField from '../TextField'
import * as yup from 'yup'
import { ButtonSubmit } from '../Button'
import OrdinaryButton from '../OrdinaryButton'
import { Stack } from '@mui/material'

export interface ThankYouDataType {
  policyNumber: string
}

export interface ThankYouInputParamsType {
  data?: ThankYouDataType
  isPageConfirmInProgress: boolean
  errorMessage: string
  onPageContinue(value: ThankYouDataType): void
}

const surveyUrl = process.env.REACT_APP_GOOGLE_REVIEW_URL

const ThankYouForm = (params: ThankYouInputParamsType) => {
  const classes = useStyles(theme)
  const history = useHistory()
  const { t } = useTranslation()
  const { state, dispatch } = useClaimant()

  const handleFormSubmit = (values: any) => {
    const thankYouDataParams: ThankYouDataType =
      transformmFormikValuesToOutput(values)
    if (typeof params?.onPageContinue === 'function')
      params.onPageContinue(thankYouDataParams)
  }

  const transformmFormikValuesToOutput = (values: any): ThankYouDataType => {
    const policyNumber: string = values.policyNumber
    return {
      policyNumber: policyNumber,
    }
  }

  const transformInputToFormikValues = (
    input: ThankYouDataType | null
  ): any => {
    const policyNumber: string = input?.policyNumber ?? ''
    return {
      policyNumber: policyNumber,
    }
  }

  const PolicySchema = () =>
    yup.object().shape({
      policyNumber: yup.string().required(t('firstPg.policyNumber.required')),
    })

  const formikInitialValues = transformInputToFormikValues(params.data ?? null)
  //console.log(state.data?.pdf)

  return (
    <Formik
      initialValues={formikInitialValues}
      onSubmit={handleFormSubmit}
      validationSchema={PolicySchema}
      enableReinitialize
    >
      {({
        values,
        errors,
        setFieldValue,
        handleChange,
        touched,
        handleBlur,
      }) => {
        return (
          <Form className={classes.root}>
            <Grid
              item
              sm={12}
              xl={12}
              xs={12}
              container
              direction="row"
              className={classes.gridMainForm}
            >
              <Grid
                item
                sm={9}
                xl={9}
                xs={12}
                container
                direction="row"
                className={classes.gridWorkArea}
              >
                <Grid
                  item
                  sm={12}
                  xs={12}
                  xl={12}
                  container
                  className={classes.gridResize}
                >
                  <Container className={classes.overviewBoxRoot}>
                    <Grid
                      container
                      direction="column"
                      justify="flex-start"
                      className={classes.overviewBoxContainer}
                    >
                      <Grid container xs={12} xl={12} sm={12} item>
                        <Typography className={classes.defaultText}>
                          {state.loadedCaseReportResp?.notifNum &&
                            ReactHtmlParser(
                              t('seventhPg.title').replace(
                                '%claim number%',
                                state.loadedCaseReportResp?.notifNum
                              )
                            )}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Container>
                  <ReportButton
                    onClick={() => {
                      const pdf = state.data?.pdf
                      if (pdf) {
                        pdf.save('CaseReport.pdf')
                      }
                    }}
                  >
                    {t('seventhPg.continueBtn')}
                  </ReportButton>
                  <Grid container item xs={12} sm={6} xl={6} className={classes.gridCenter} style={{alignSelf: 'center', marginTop: '2em'}}>
                    <Typography style={{ color: specialTheme.colors.darkRed }}>{t('seventhPg.surveyLabel')}</Typography>
                    <OrdinaryButton onClick={() => {
                      window.open(surveyUrl, "_blank", "noopener,noreferrer");
                      }}>{t('seventhPg.surveyBtn')}</OrdinaryButton>
                  </Grid>
                  <BackButtonLayout
                    text={t('seventhPg.backBtn')}
                    onClick={() => {
                      dispatch({
                        type: 'initial_state',
                        payload: { page: 0 },
                      })
                      /*dispatch({
              type: 'update_page',
              payload: { page: 0 },
            })*/
                      isDEV
                        ? history.push(pathToRootPage)
                        : (window.location.href = pathToLeadingPage)
                    }}
                  />
                  {state.caseType === 'TI' && (
                    <React.Fragment>
                      <Grid
                        item
                        xl={12}
                        xs={12}
                        sm={12}
                        className={classes.gridItem}
                        container
                        direction="row"
                      >
                        <Typography className={classes.textStyle}>
                          {t('seventhPg.anotherClaim')}
                        </Typography>
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          xl={12}
                          container
                          className={classes.gridItem}
                          spacing={2}
                        >
                          <Grid item xl={6} xs={6} sm={6}>
                            <TextField
                              // @ts-ignore
                              label={t('firstPg.policyNumber.labelTI')}
                              name="policyNumber"
                              value={values.policyNumber}
                              error={!!(
                                errors.policyNumber && touched.policyNumber)
                              }
                              placeholder={t('firstPg.policyNumber.hint')}
                              helperText={
                                errors.policyNumber && touched.policyNumber
                                  ? errors.policyNumber
                                  : null
                              }
                              onChange={handleChange}
                              className={classes.fieldSize}
                              InputProps={{ required: false }}
                              inputProps={{ maxLength: 20 }}
                              onBlur={handleBlur}
                            />
                          </Grid>
                        </Grid>
                        <ButtonSubmit>
                          {t('continueBtn')}
                        </ButtonSubmit>
                      </Grid>
                    </React.Fragment>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Form>
        )
      }}
    </Formik>
  )
}
export default ThankYouForm
